module.exports = __webpack_public_path__ + "img/yellow.dd90e6b3.svg";